import { render } from "./RowCategory.vue?vue&type=template&id=8838f3ce&scoped=true"
import script from "./RowCategory.vue?vue&type=script&lang=js"
export * from "./RowCategory.vue?vue&type=script&lang=js"

import "./RowCategory.vue?vue&type=style&index=0&id=8838f3ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8838f3ce"]])

export default __exports__